<template>
    <div class="photo-viewer-panel"
    >
        <ui-button icon="magicon-close" class="close-button" @click="close"/>

        <div class="image-container" ref="imageContainer">
            <div ref="image" class="image" :style="{ backgroundImage: `url(${image.url})` }" ></div>
        </div>

        <table>
            <tr>
                <td class="key">Actie</td>
                <td class="value">{{ action.__typename | actionTypeTitle(action) }}</td>
            </tr>
            <tr>
                <td class="key">Datum</td>
                <td class="value">{{ action.date | date('DD MMMM YYYY') }}</td>
            </tr>
            <tr>
                <td class="key">Perceel</td>
                <td class="value">{{ section.parcel.parcelLocation.name }} {{ section.parcel.parcelLocation.number }} - {{ section.parcel.alias }}</td>
            </tr>
            <tr>
                <td class="key">Vak</td>
                <td class="value">{{ section.name }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
import Vue from 'vue';
import Panzoom from '@panzoom/panzoom';
import Component from 'vue-class-component';

@Component({

    name: 'PhotoViewerPanel',
    props: {
        action: {
            type: Object,
            required: true
        },
        section: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        }
    },
    emits: ['dismiss']
})
export default class PhotoViewerPanel extends Vue {

    panzoom = null;

    mounted() {

        const imageEl = this.$refs.image;
        const containerEl = this.$refs.imageContainer;

        this.panzoom = Panzoom(imageEl, {
            maxScale: 4,
            minScale: 1,
            contain: 'outside',
            cursor: 'move'
        });

        containerEl.addEventListener('wheel', this.panzoom.zoomWithWheel, { passive: false });
        imageEl.addEventListener('dblclick', this.onDoubleClick);
    }

    beforeDestroy() {

        const imageEl = this.$refs.image;
        const containerEl = this.$refs.imageContainer;

        if(this.panzoom) {

            containerEl.removeEventListener('wheel', this.panzoom.zoomWithWheel);
            imageEl.removeEventListener('dblclick', this.onDoubleClick);
            this.panzoom.destroy();
            this.panzoom = null;
        }
    }

    onDoubleClick(event) {

        if(!this.panzoom) {
            return;
        }

        const targetScale = this.panzoom.getScale() > 1 ? 1 : 2;

        this.panzoom.zoomToPoint(targetScale, {
            clientX: event.clientX,
            clientY: event.clientY
        });
    }

    close() {

        this.$emit('dismiss');
    }

    get images() {

        return this.action.actionImages.items;
    }

    get image() {

        return this.images[this.index];
    }
}
</script>
